import { useCallback } from 'react';
import { useQueryClient } from 'react-query';

import { SCOPES } from '~/api/routes/auth/user';
import { useAuthSelector } from '~/theseus/containers/Auth';

import useAuthStatus from '~/theseus/hooks/useAuthStatus';

function useAuthModalState() {
  const appRequirements = useAuthStatus();

  const isOwner = useAuthSelector((state) => state.context?.rgUser?.owner);
  const isLoggedIn = useAuthSelector((state) => state.matches('loggedIn'));
  const accessToken = useAuthSelector((state) => state.context.authToken);

  const queryClient = useQueryClient();

  const allRequirementsLoaded = appRequirements.pages.isFetched
    && appRequirements.accounts.isFetched
    && appRequirements.permissions.isFetched
    && appRequirements.fbPixel.isFetched
    && appRequirements.fundingSource.isFetched;

  const hasAllRequirements = appRequirements.accounts.valid
    && appRequirements.accounts.isFetched
    && appRequirements.permissions.isFetched
    && appRequirements.fbPixel.isFetched
    && appRequirements.fundingSource.isFetched
    && appRequirements.siteEnabled
    && appRequirements.isAuthorized
    && appRequirements.adBlockerDisabled
    && appRequirements.hasPageAccess;

  // This will open up a Facebook login window that will allow users to enable
  // all of the permissions
  const openFbRerequestModal = useCallback(() => {
    const scope = SCOPES.join();

    FB.login(() => {
      queryClient.invalidateQueries(['permissions', accessToken]);
    }, { auth_type: 'rerequest', scope });
  }, [queryClient, accessToken]);

  return {
    isOpen: allRequirementsLoaded && isLoggedIn && !hasAllRequirements,
    isOwner,
    hasAllRequirements,
    openFbRerequestModal,
    appRequirements,
  };
}

export default useAuthModalState;
